const CHAT_PROVIDER_ID = 'copilot';
export { CHAT_PROVIDER_ID };
